import { render, staticRenderFns } from "./MainTitle.vue?vue&type=template&id=072c51b8&scoped=true"
import script from "./MainTitle.vue?vue&type=script&lang=js"
export * from "./MainTitle.vue?vue&type=script&lang=js"
import style0 from "./MainTitle.vue?vue&type=style&index=0&id=072c51b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c51b8",
  null
  
)

export default component.exports